const getFormValue = (formObject) => {
  return formObject.value;
};

export { getFormValue };
